import React from 'react';
import '../../styles/_forms.less';
import {List} from 'immutable';

/**
 * Elements divers pour la gestion simple des formulaires
 * @module
 */


/** Composant de base d'un formulaire */
export var Form = ({children, ...props}) => {

  return (
    <form {...props}>
      {children}
      <div style={{clear: 'both'}}></div>
    </form>
  )
};



/** Champ dans le formulaire, gère la récupération de valeurs et les multiples types possibles*/
export class Field extends React.Component {

  theValue() {
    let el = this.refs.input;
    if (this.props.ofType === 'select') {
      return el[el.selectedIndex].value;
    } else if (this.props.ofType === 'file') {
      return el.files[0];
    } else {
      return el.value;
    }
  }

  value() {
    return this.theValue();
  }

  focus() {
    this.refs.input.focus();
  }

  validate() {
    const validateWith = this.props.validateWith;
    const validationError = this.props.validationError || 'Saisie invalide';
    const input = this.refs.input;
    const value = this.theValue();

    input.setCustomValidity('');

    if (validateWith && validateWith instanceof Function) {
      if (!validateWith(value)) {
        input.setCustomValidity(validationError);
      }
    }
  }

  componentWillReceiveProps({value}) {
    if (this.props.ofType === 'file') {
      return;
    }
    this.refs.input.value = value || '';
  }

  render() {
    const {ofType, label, children, required, disabled, value = '', validateWith} = this.props;
    let input = null;
    let pattern = null;

    switch (validateWith) {
      case 'latitude':
      case 'longitude':
        pattern = '-?[0-9]{1,3}\.[0-9]+';
        break;
      case 'min3':
        pattern = '.{3,}';
        break;
    }

    switch (ofType) {
      case 'date':
        input = <input type="text" ref="input" defaultValue={value}
                       required={required} pattern="^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$"
                       placeholder="AAAA-MM-JJ"
                       disabled={disabled}
                       onChange={() => this.validate()}/>;
            break;
      case 'url':
      case 'password':
      case 'phone':
      case 'email':
      case 'text':
      case 'file':
        input = <input type={ofType} ref="input" defaultValue={value}
                       required={required} disabled={disabled} pattern={pattern} onChange={() => this.validate()}/>;
        break;
      case 'select':
        input = <select ref="input"
                        required={required} disabled={disabled} defaultValue={value}
                        onChange={() => this.validate()}>{children}</select>;
        break;
      case 'textarea':
        input = <textarea
          ref="input"
          required={required} disabled={disabled} onChange={() => this.validate()}
          defaultValue={value}/>;
        break;
    }
    return (
      <div className="r-field">
        <div className={required ? 'required' : null}>{label}</div>
        {input}
      </div>
    );
  }
}


/** Item dans la liste d'élements d'une combo box */
export var Option = ({value, label}) => {
  label = label || value;
  return <option value={value}>{label}</option>;
};


/** Select qui gère la sélection multiple (en entrée et en sortie) */
export class MultiSelect extends React.Component {

  constructor() {
    super();
    this.state = {
      selectedIds: List()
    };
  }

  componentDidMount() {
    this.setState({selectedIds: List(this.props.selectedIds)});
  }

  componentWillReceiveProps({selectedIds}) {
    this.setState({selectedIds: List(selectedIds)});
  }

  value() {
    return this.state.selectedIds;
  }

  toggleValue(id) {
    const {selectedIds} = this.state;
    if (selectedIds.contains(id)) {
      this.setState({selectedIds: selectedIds.filterNot(v => v == id)});
    } else {
      this.setState({selectedIds: selectedIds.push(id)});
    }
  }

  render() {
    const {required, label, choices} = this.props;
    return (
      <div className="r-field">
        <div className={required ? 'required' : null}>{label}</div>
        <ul className="radio-list">
          {Object.keys(choices).map((c, i) => {
            let v = choices[c];
            return (
              <li key={i}>
                <input type="checkbox" id={`opt-${i}`} name="selector" value={v.id}
                       checked={this.state.selectedIds.contains(v.id)}
                       onChange={() => this.toggleValue(v.id)}/>
                <label htmlFor={`opt-${i}`}>{c}</label>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}


/** Coupe l'espace horizontalement pour accueil deux enfants à 50% */
export class Split extends React.Component {
  value() {
    let [c1, c2] = this.props.children;
    return Object.assign.call(Object, {}, c1.value(), c2.value());
  }

  render() {
    if (this.props.children === undefined) {
      return <div></div>;
    }
    let [c1, c2] = this.props.children;
    return (
      <div className="split">
        <div style={{width: '50%', float: 'left', paddingRight: 10}}>
          {c1}
        </div>
        <div style={{width: '50%', float: 'right', paddingLeft: 10}}>
          {c2}
        </div>
      </div>

    );
  }
}


/** Barre horizontale qui accueille un premier enfant à droite (aciton principale) et un autre à gauche */
export var ButtonBar = ({children}) => {
  if (children && children.length > 1) {
    return (
      <div>
        <div style={{float: 'right'}}>{children[0]}</div>
        <div style={{float: 'left'}}>{children[1]}</div>
      </div>
    );
  } else {
    return <div style={{float: 'right'}}>{children}</div>;
  }

};


/** Bouton de sauvegarde */
export var SaveButton = ({
  onClick = () => {
  }
}) => {
  return (
    <button type="submit" className="r-button" onClick={onClick}>
      <i className="mi mi-save"/>
    </button>
  );
};


/** Bouton d'ajout */
export var AddButton = ({
  onClick = () => {
  }
}) => {
  return (
    <button type="submit" className="r-button" onClick={onClick}>
      <i className="mi mi-add"/>
    </button>
  );
};



/** Bouton de suppression */
export var DeleteButton = ({
  onClick = () => {
  }
}) => {
  return (
    <button type="button" className="r-button" onClick={onClick}>
      <i className="mi mi-delete"
         style={{color: 'orange'}}/>
    </button>
  );
};



// WEBPACK FOOTER //
// ./src/components/commons/Forms.js